<template>
    <div class="mapDetail" :class="isShow ? 'l0' : 'l300'">
        <div class="close">
            <i class="el-icon-circle-close" @click="closeFn"></i>
        </div>
        <div class="formContent">
            <el-form ref="form" :model="dioForm" :rules="rules" label-width="60px">
                <el-form-item :label="$t('integration.place')" prop="address">
                    <div class="uk-flex uk-flex-middle">
                        <el-input id="tipinput" v-model.trim="dioForm.address" style="width: 168px;margin-right:3px" :placeholder="$t('integration.please_enter_the_location')" />
                        <el-button type="primary" icon="el-icon-search" @click="searchFn"></el-button>
                    </div>
                </el-form-item>
                <el-form-item :label="longitudeLabel" prop="longitude">
                    <el-input v-model.trim="dioForm.longitude" style="width: 168px;" :placeholder="$t('integration.please_enter_longitude')" />
                </el-form-item>
                <el-form-item :label="latitudeLabel" prop="latitude">
                    <el-input v-model.trim="dioForm.latitude" style="width: 168px;" :placeholder="$t('integration.please_enter_the_latitude')" />
                </el-form-item>
                <el-form-item>
                    <el-button @click="locationFn" type="primary" style="width: 168px;">{{ $t('integration.location') }}</el-button>
                </el-form-item>
            </el-form>
            <!-- 搜索点的窗体 -->
            <div v-if="pointShow">
                <div class="searchWin" v-if="ponitArray.length > 0">
                    <div class="close" style="height:30px">
                        <i class="el-icon-circle-close uk-margin-small-top" @click="closePoint"></i>
                    </div>
                    <div class="amap-pl-pc" v-for="(item, index) in ponitArray" :key="index" @click="openMarkerTipById1(index, $event, item)" @mouseout="onmouseout_MarkerStyle(index + 1, $event)">
                        <div class="poibox">
                            <div class="amap_lib_placeSearch_poi poibox-icon" :class="index == selectedIndex ? 'selected' : ''">
                                {{ index + 1 }}
                            </div>
                            <div class="poi-img" v-if="item.url" :style="'background-image:url(' + item.url + '?operate=merge&amp;w=90&amp;h=56&amp;position=5)'"></div>
                            <h3 class="poi-title">
                                <span class="poi-name">{{ item.name }}</span>
                            </h3>
                            <div class="poi-info">
                                <p class="poi-addr">{{ $t('text.Address') }}：{{ item.address }}</p>
                                <p class="poi-tel">{{ $t('text.Phone') }}：{{ item.tel }}</p>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
                <div class="searchWin" v-if="ponitArray.length === 0 && this.isBoolShowWin">
                    <el-empty :description="$t('integration.no_data_temporarily')"></el-empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['isShow', 'poiArr', 'isBoolShowWin', 'initObj', 'mapObj'],
    computed: {
        rules() {
            let longFn = (rules, value, cb) => {
                let reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,20})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,20}|180)$/;
                if (!reg.test(value)) {
                    cb($t('integration.the_longitude_entered_is_illegal'));
                }
                cb();
            };
            let latFn = (rules, value, cb) => {
                let reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,20}|90\.0{0,20}|[0-8]?\d{1}|90)$/;
                if (!reg.test(value)) {
                    cb($t('integration.the_latitude_entered_is_illegal'));
                }
                cb();
            };
            return {
                longitude: [
                    { required: true, message: $t('integration.longitude_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: longFn,
                        trigger: 'blur'
                    }
                ],
                latitude: [
                    { required: true, message: $t('integration.latitude_cannot_be_empty'), trigger: 'blur' },
                    {
                        validator: latFn,
                        trigger: 'blur'
                    }
                ]
            };
        },
        // 经纬度 label：中文用原翻译，英文用缩写避免被截断
        longitudeLabel() {
            return this.$i18n.locale === 'zh_CN' ? this.$t('integration.longitude') : 'Lng'
        },
        latitudeLabel() {
            return this.$i18n.locale === 'zh_CN' ? this.$t('integration.latitude') : 'Lat'
        }
    },
    watch: {
        poiArr(newVal) {
            this.selectedIndex = -1;
            this.ponitArray = [...newVal];
        },
        initObj(newVal) {
            this.dioForm = { ...newVal };
        }
    },
    data() {
        return {
            dioForm: {
                address: $t('integration.runhui_science_park'),
                longitude: '113.43403',
                latitude: '23.173214'
            },
            selectedIndex: -1,
            autoOptions: {
                input: 'tipinput'
            },
            ponitArray: [],
            pointShow: false
        };
    },
    methods: {
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        async locationFn() {
            let flag = await this.justify();
            if (!flag) return;

            this.$emit('locationFn', this.dioForm);
        },
        closeFn() {
            this.$emit('closeFn');
        },
        //  关键字搜素
        searchFn() {
            this.$emit('searchFn', this.dioForm.address);
            this.pointShow = true;
        },
        openMarkerTipById1(pointid, thiss, item) {
            this.dioForm.address = item.address + `(${item.name})`;
            this.dioForm.longitude = item.location.lng;
            this.dioForm.latitude = item.location.lat;
            //是从地址上选择的 不需要做地址转换
            this.dioForm.addressCheck = true;

            //根据id 打开搜索结果点tip
            thiss.currentTarget.style.background = '#CAE1FF';
            this.selectedIndex = pointid;
            this.$parent.map = this.$parent.marker[pointid];

            window.removeEventListener('click', this.$parent.demo);
            this.$parent.windowsArr[pointid].open(this.$parent.newMap, this.$parent.marker[pointid]);
            window.addEventListener('click', this.$parent.demo);
            this.pointShow = false;
        },
        onmouseout_MarkerStyle(pointid, thiss) {
            //鼠标移开后点样式恢复
            thiss.currentTarget.style.background = '';
        },
        closePoint() {
            this.pointShow = false;
        }
    },
    mounted() {
        if (this.mapObj) {
            this.dioForm = { ...this.mapObj };
            //this.searchFn();
        }
    }
};
</script>

<style lang="scss" scoped>
.mapDetail {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 300px;
    z-index: 99;
    background: rgba(255, 255, 255, 0.7);
    transition: all 1s;
    padding: 10px;
    box-sizing: border-box;

    .close {
        height: 50px;

        i {
            float: right;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;

            &:hover {
                color: red;
            }
        }
    }

    .formContent {
        position: relative;
    }

    .searchWin {
        position: absolute;
        top: -60px;
        left: 300px;
        width: 300px;
        height: 500px;
        overflow: auto;
        background: rgba($color: #ffffff, $alpha: 0.7);

        .poibox {
            border-bottom: 1px solid #eaeaea;
            cursor: pointer;
            padding: 5px 0 5px 10px;
            position: relative;
            min-height: 35px;

            .poi-title {
                margin-left: 25px;
                font-size: 13px;
                overflow: hidden;
            }

            .poi-info {
                word-break: break-all;
                margin: 0 0 0 25px;
                overflow: hidden;
            }

            .poi-info p {
                color: #999;
                font-family: Tahoma;
                line-height: 20px;
                font-size: 12px;
            }

            .poibox-icon {
                margin-left: 7px;
                margin-top: 4px;
            }

            &:hover {
                background: #f6f6f6;
            }
        }

        /* [AMap removed] .amap_lib_placeSearch_poi {
            background: url(https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png) no-repeat;
            height: 31px;
            width: 19px;
            cursor: pointer;
            left: -1px;
            text-align: center;
            color: #fff;
            font: 12px arial, simsun, sans-serif;
            padding-top: 3px;
        } */

        /* [AMap removed] .selected {
            background: url(https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png) !important;
        } */

        /* [AMap removed] .amap_lib_placeSearch_poi {
            position: absolute;
        } */

        /* [AMap removed] .amap-pl-pc .poi-img {
            float: right;
            margin: 3px 8px 0;
            width: 90px;
            height: 56px;
            overflow: hidden;
        } */

        /* [AMap removed] .amap-info-content {
            width: 200px !important;
        } */
    }
}

.l0 {
    left: 0px;
}

.l300 {
    left: -300px;
}
</style>
